import { Box } from '../Box';
import React from 'react';

export const Label = ({ children, ...props }) => (
    <Box as={'label'} color={'#595959'} width={'100%'} fontWeight={'bold'} {...props}>
        {children}
    </Box>
);
